import React from "react";
import UrlHelper from "../../utilities/UrlHelper";

const PrivacyLinksRow = () => {
    return (
        <div className="newPages-form-privacy">
            <small className="notice-link">
                <a href={UrlHelper.getIdentifiUrl() + "GovernmentRestrictedRightsNotice.pdf"} target="_blank" rel ="noopener" tabIndex="3">Government
                Restricted Rights</a>
            </small>
        </div>
    );
};

export default PrivacyLinksRow;
